import "./style.scss";

const AB_2659 = ({ id = "", label = "", onClick = () => {}, className = "", icon = null, disabled = false, iconPos = "right", type = "", loaderBtn, loading, typeButton = "" }) => {
    const isLoading = Boolean(loaderBtn ?? loading);
    const isDisabled = disabled || isLoading;

    const handleClick = (e) => {
        if (isDisabled) return;
        onClick(e);
    };

    const renderIcon = () => {
        if (!icon) return null;
        if (typeof icon === "string") return <img src={icon} />;
        return icon;
    };

    return (
        <button id={id} type="button" className={` ab-2659 button-ui ${className} ${type} ${typeButton}`.trim()} onClick={handleClick} disabled={isDisabled} aria-busy={isLoading}>
            {isLoading ? (
                <div className="loader__btn">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            ) : (
                <>
                    {icon && iconPos === "left" && renderIcon()}
                    {!label.length && icon && icon === "center" ? renderIcon() : null}
                    {label && <span className="button-ui__label">{label}</span>}
                    {icon && iconPos === "right" && renderIcon()}
                </>
            )}
        </button>
    );
};

export default AB_2659;
